import { render, staticRenderFns } from "./medicalDetails.vue?vue&type=template&id=5d974649&scoped=true&"
import script from "./medicalDetails.vue?vue&type=script&lang=js&"
export * from "./medicalDetails.vue?vue&type=script&lang=js&"
import style0 from "./medicalDetails.vue?vue&type=style&index=0&id=5d974649&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d974649",
  null
  
)

export default component.exports